import React from 'react';
import QueueContainer from 'PointOfSale/modules/queue/container/QueueContainer';
import LookUpNavigationContainer from 'PointOfSale/modules/lookup/container/LookUpNavigationContainer';
import LastTransactionDetails from 'PointOfSale/modules/common/container/LastTransactionDetails';

const QueueSideBar = props => {
  return (
    <React.Fragment>
      <LookUpNavigationContainer />
      <QueueContainer />
      <LastTransactionDetails />
    </React.Fragment>
  );
};

export default QueueSideBar;



// WEBPACK FOOTER //
// ./src/pages/pointofsale/modules/queue/component/QueueSideBar.js